import type { IconProps } from "./icon-types";

/**
 * 위/아래 chevron 쌍(정렬 토글·콤보박스 개폐 표시). `ChevronIcon`과 같은
 * 16그리드·stroke 1.8로 chevron 가족의 시각 굵기를 통일한다.
 */
export const ChevronsUpDownIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true" {...props}>
    <path
      d="M4 6.5l4-4 4 4M4 9.5l4 4 4-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
